import * as ConstantRouter from '@/constant/router';
import * as ConstantLabel from '@/constant/label';

const route = {
  path: 'sources',
  name: ConstantRouter.SOURCES,
  component: () => import(/* webpackChunkName: "sources" */ '@/pages/sources/index.vue'),
  meta: {
    name: ConstantLabel.SOURCES,
    showUploadBox: true,
  },
};

export default route;
